import type {
  TprInsuranceRequirementsOutput,
  TprReferralAuthorizationOutput,
} from "@/src/lib/workflows/steps/step-outputs";

export function tprReferralAuthNeedsPendingUpload(
  authorization: TprReferralAuthorizationOutput | null | undefined
): boolean {
  if (!authorization) return false;
  if (authorization.outcome === "needs_pending_request") return true;

  return authorization.outcome === "created" && authorization.write === "authorization" && authorization.pending;
}

export function tprReferralAuthNeedsReview(
  authorization: TprReferralAuthorizationOutput | null | undefined,
  requirements?: TprInsuranceRequirementsOutput | null
): boolean {
  if (requirements?.clinicNetwork === "in_network" && requirements.providerNetwork === "in_network") {
    if (authorization?.outcome === "not_needed" && authorization.reason !== "not_required") return true;
    if (requirements.authorizationRequirement === "required" || requirements.referralRequirement === "required") {
      if (authorization?.outcome !== "created" || !authorization.referralAuthId) return true;
      if (requirements.authorizationRequirement === "required" && authorization.write !== "authorization") return true;
    }
  }

  if (!authorization) return false;
  if (authorization.outcome === "needs_review") return true;

  return authorization.outcome === "not_needed" && authorization.reason === "requirements_unresolved";
}
